<template>
  <type-based-transition :transitionType="'fadeUpDown'">
    <div v-if="isComplete" id="complete" class="form-complete">
      <section v-if="!displayMorePsychologyInfo" class="form-complete-inner">
        <div class="recipe-valid" v-if="isValidForRecipe">
          <h1>Tack för dina svar</h1>
          <h4> Vi vill erbjuda dig recept. Nedan kan du läsa om möjlig bakomliggande orsak till just dina besvär.</h4> 
          <div @click="goToCheckout('recipe')" class="recipe-btn">Skicka receptförfrågan</div>
        </div>
        <component v-bind:is="resultTemplate" />
        <div v-if="isValidForPsychologicalTreatment && displayPsychologyTreatmentInfo && !displayMorePsychologyInfo" class="psychology-info-area">
          <span v-if="psychologyIsPrimaryReason">
            Psykologiska faktorer kan i många fall också lösas av att prata med någon. Impotens av psykologisk orsak kan i många fall lösas i samtal med psykolog. Genom oss på Potenshjälpen har du möjlighet att boka tid för psykologisk behandling.
          </span>
          <span v-else>
            Eftersom misstanke om psykologisk orsak även uppkommit rekommenderar vi dig att ta kontakt med psykolog eller sexolog för diskussion om din situation. Genom oss på Potenshjälpen har du möjlighet att boka tid för psykologisk behandling.
          </span>
          <div @click="toggleDisplayPsychologyInfo" class="recipe-btn psychology-info">Om psykologisk behandling</div>
        </div>

        <div class="recipe-button-area" v-if="isValidForRecipe && !displayMorePsychologyInfo">
          <div class="recipe-info"><span class="icon"><Zondicon icon="ExclamationOutline"/></span><span class="info">Vid receptförfrågan skickas ditt formulär till en legitimerad läkare. Vi utvärderar ditt resultat och tar ett slutgiltigt beslut om receptförskrivning.
            Om vi bedömer att du inte bör använda Sildenafil återbetalas pengarna inom sju dagar.</span></div>
        </div>
      </section>

      <section class="psychology-more-info" v-if="displayMorePsychologyInfo">

        <h2>Psykologisk behandling</h2>

        <img src="../../assets/img/vega-psykologi-logo.png" class="vega-logo" width="240px" />

        <p>Potenshjälpen samarbetar med Vega Psykologi för stöd och behandling av psykologiska besvär kopplat till erektionsproblem. Det kan exempelvis handla om prestationsångest, stress, nedstämdhet eller relationsproblem. Vega Psykologi kan erbjuda snabba tider till erfarna psykologer, antingen digitalt via videolänk eller på mottagning i Stockholm, Borås eller Alingsås.</p>

        <p>Om du skickar vidare formuläret kommer du att kontaktas av Vega Psykologi och erbjudas tid för samtal. Genom att skicka formuläret godkänner du att den enskilda psykologen som tar sig an ditt fall har rätt att läsa svaren i formuläret i din journal. Kostnaden för 50 minuters terapi är 1100 kr. Fakturering sker först efter genomfört samtal.</p>

        <div @click="goToCheckout('psychologist')" class="recipe-btn psychology-booking">Boka psykologisk behandling</div>
        <div @click="toggleDisplayPsychologyInfo" class="recipe-btn psychology-back">&laquo; Tillbaka till recept</div>

      </section>

    </div>
  </type-based-transition>
</template>
<script>
import TypeBasedTransition from "../Transitions/TypeBasedTransition.vue"
import { getFieldDefinition } from "../FieldResultDefinitions"

// Result templates
import NoSymptomsTemplate from "./ResultTemplates/NoSymptomsTemplate"
import NoIndicatorsTemplate from "./ResultTemplates/NoIndicatorsTemplate"
import O_VascularTemplate from "./ResultTemplates/O_VascularTemplate"
import O_NervTemplate from "./ResultTemplates/O_NervTemplate"
import O_HormonalTemplate from "./ResultTemplates/O_HormonalTemplate"
import O_PsychologicalTemplate from "./ResultTemplates/O_PsychologicalTemplate"
import KO_AlcoholTemplate from "./ResultTemplates/KO_AlcoholTemplate"
import KO_HeartTemplate from "./ResultTemplates/KO_HeartTemplate"
import KO_StrokeTemplate from "./ResultTemplates/KO_StrokeTemplate"
import KO_LiverKidneyTemplate from "./ResultTemplates/KO_LiverKidneyTemplate"
import KO_BloodPressureTemplate from "./ResultTemplates/KO_BloodPressureTemplate"
import KO_AnatomyTemplate from "./ResultTemplates/KO_AnatomyTemplate"
import KO_TraumaticVascularTemplate from "./ResultTemplates/KO_TraumaticVascularTemplate"
import KO_MedicineTemplate from "./ResultTemplates/KO_MedicineTemplate"
import KO_MedicineAdempasTemplate from "./ResultTemplates/KO_MedicineAdempasTemplate"
import KO_MedicineHivTemplate from "./ResultTemplates/KO_MedicineHivTemplate"
import KO_MedicineCancerTemplate from "./ResultTemplates/KO_MedicineCancerTemplate"
import KO_HeartAndStrokeTemplate from "./ResultTemplates/KO_HeartAndStrokeTemplate"
import KO_BloodPressureAndLiverKidneyTemplate from "./ResultTemplates/KO_BloodPressureAndLiverKidneyTemplate"
import KO_BloodPressureAndAnatomyTemplate from "./ResultTemplates/KO_BloodPressureAndAnatomyTemplate"
import KO_AnatomyAndLiverKidneyTemplate from "./ResultTemplates/KO_AnatomyAndLiverKidneyTemplate"
import KO_BloodPressureAndAnatomyAndLiverKidneyTemplate from "./ResultTemplates/KO_BloodPressureAndAnatomyAndLiverKidneyTemplate"
import KO_MedicineHivAndCancerTemplate from "./ResultTemplates/KO_MedicineHivAndCancerTemplate"
import CheckoutTemplate from "../CheckoutTemplate"

import { INDICATOR } from "../../config/indicators"
import formConfig from "../../config/formConfig.json"

export default {
  name: "form-result",
  inject: ["formState"],
  components: {
    TypeBasedTransition,
    NoSymptomsTemplate,
    NoIndicatorsTemplate,
    O_VascularTemplate,
    O_NervTemplate,
    O_HormonalTemplate,
    O_PsychologicalTemplate,
    KO_AlcoholTemplate,
    KO_HeartTemplate,
    KO_StrokeTemplate,
    KO_LiverKidneyTemplate,
    KO_BloodPressureTemplate,
    KO_AnatomyTemplate,
    KO_TraumaticVascularTemplate,
    KO_MedicineTemplate,
    KO_MedicineAdempasTemplate,
    KO_MedicineHivTemplate,
    KO_MedicineCancerTemplate,
    KO_HeartAndStrokeTemplate,
    KO_BloodPressureAndLiverKidneyTemplate,
    KO_BloodPressureAndAnatomyTemplate,
    KO_AnatomyAndLiverKidneyTemplate,
    KO_BloodPressureAndAnatomyAndLiverKidneyTemplate,
    KO_MedicineHivAndCancerTemplate,
    CheckoutTemplate
  },
  methods: {
    goToPage(index) {
      this.formState.activeField = index
    },
    setResultTemplate(template) {
      this.resultTemplate = template
    },
    toggleDisplayPsychologyInfo() {
      this.displayMorePsychologyInfo = !this.displayMorePsychologyInfo
    },
    goToCheckout(confirmationType) {
      pushBankIdEventToDataLayer("bankid-initiated");

      this.$store.commit( 'persist/setFinalFormData', { finalFormData: this.kaddioData } );
      this.$store.commit( 'persist/setConfirmationType', { confirmationType: confirmationType } );

      this.displayMorePsychologyInfo = false
      this.formState.validForRecipe = false
      this.formState.displayPsychologyTreatmentInfo = false
      this.formState.psychologyIsPrimary = false
      this.resultTemplate = "CheckoutTemplate"
    },
    changeTemplate(newVal) {
      this.resultTemplate = newVal
    }
  },
  data() {
    return {
      resultTemplate: "",
      displayMorePsychologyInfo: false
    }
  },
  watch: {
    isComplete(newValue) {
      if (newValue) {
        this.formState.validForRecipe = false

        if (!this.formState.hasSymptoms) {
          this.setResultTemplate(INDICATOR.NO_SYMPTOM + "Template")
          this.formState.validForRecipe = false
        } else {
          
          // Orsakstexter

          // No indicators
          if (!this.hasOVask && !this.hasONerv && !this.hasOHorm && !this.hasOPsyk) {
            this.setResultTemplate(INDICATOR.NO_INDICATOR + "Template")
            this.formState.additionalInfo_alt1 = ""
            this.formState.additionalInfo_alt2 = ""
            this.formState.additionalInfo_alt3 = ""
            this.formState.validForRecipe = true
            this.formState.isValidForPsychologicalTreatment = false
            this.formState.displayPsychologyTreatmentInfo = false
          }

          // Only OVask
          if (this.hasOVask && !this.hasONerv && !this.hasOHorm && !this.hasOPsyk) {
            this.setResultTemplate(INDICATOR.O_VASK + "Template")
            this.formState.additionalInfo_alt1 = ""
            this.formState.additionalInfo_alt2 = ""
            this.formState.additionalInfo_alt3 = ""
            this.formState.validForRecipe = true
            this.formState.isValidForPsychologicalTreatment = false
            this.formState.displayPsychologyTreatmentInfo = false
          }

          // Only ONerv
          if (!this.hasOVask && this.hasONerv && !this.hasOHorm && !this.hasOPsyk) {
            this.setResultTemplate(INDICATOR.O_NERV + "Template")
            this.formState.additionalInfo_alt1 = ""
            this.formState.additionalInfo_alt2 = ""
            this.formState.additionalInfo_alt3 = ""
            this.formState.validForRecipe = true
            this.formState.isValidForPsychologicalTreatment = false
            this.formState.displayPsychologyTreatmentInfo = false
          }

          // Only OHorm
          if (!this.hasOVask && !this.hasONerv && this.hasOHorm && !this.hasOPsyk) {
            this.setResultTemplate(INDICATOR.O_HORM + "Template")
            this.formState.additionalInfo_alt1 = ""
            this.formState.additionalInfo_alt2 = ""
            this.formState.additionalInfo_alt3 = ""
            this.formState.validForRecipe = true
            this.formState.isValidForPsychologicalTreatment = false
            this.formState.displayPsychologyTreatmentInfo = false
          }

          // Only OPsyk
          if (!this.hasOVask && !this.hasONerv && !this.hasOHorm && this.hasOPsyk) {
            this.setResultTemplate(INDICATOR.O_PSYK + "Template")
            this.formState.additionalInfo_alt1 = ""
            this.formState.additionalInfo_alt2 = ""
            this.formState.additionalInfo_alt3 = ""
            this.formState.validForRecipe = true
            this.formState.isValidForPsychologicalTreatment = true
            this.formState.displayPsychologyTreatmentInfo = true
            this.formState.psychologyIsPrimary = true
          }

          // COMBINATIONS

          // OVask + ONerv combined
          if (this.hasOVask && this.hasONerv && !this.hasOHorm && !this.hasOPsyk) {
            this.setResultTemplate(INDICATOR.O_VASK + "Template")
            this.formState.additionalInfo_alt1 = INDICATOR.O_NERV
            this.formState.additionalInfo_alt2 = ""
            this.formState.additionalInfo_alt3 = ""
            this.formState.validForRecipe = true
            this.formState.isValidForPsychologicalTreatment = false
            this.formState.displayPsychologyTreatmentInfo = false
          }

          // OVask + OPsyk combined
          if (this.hasOVask && !this.hasONerv && !this.hasOHorm && this.hasOPsyk) {
            this.setResultTemplate(INDICATOR.O_VASK + "Template")
            this.formState.additionalInfo_alt1 = INDICATOR.O_PSYK
            this.formState.additionalInfo_alt2 = ""
            this.formState.additionalInfo_alt3 = ""
            this.formState.validForRecipe = true
            this.formState.isValidForPsychologicalTreatment = true
            this.formState.displayPsychologyTreatmentInfo = true
          }

          // OVask + OHorm combined
          if (this.hasOVask && !this.hasONerv && this.hasOHorm && !this.hasOPsyk) {
            this.setResultTemplate(INDICATOR.O_VASK + "Template")
            this.formState.additionalInfo_alt1 = INDICATOR.O_HORM
            this.formState.additionalInfo_alt2 = ""
            this.formState.additionalInfo_alt3 = ""
            this.formState.validForRecipe = true
            this.formState.isValidForPsychologicalTreatment = false
            this.formState.displayPsychologyTreatmentInfo = false
          }

          // OVask + ONerv + OHorm combined
          if (this.hasOVask && this.hasONerv && this.hasOHorm && !this.hasOPsyk) {
            this.setResultTemplate(INDICATOR.O_VASK + "Template")
            this.formState.additionalInfo_alt1 = INDICATOR.O_NERV
            this.formState.additionalInfo_alt2 = INDICATOR.O_HORM
            this.formState.additionalInfo_alt3 = ""
            this.formState.validForRecipe = true
            this.formState.isValidForPsychologicalTreatment = false
            this.formState.displayPsychologyTreatmentInfo = false
          }

          // OVask + ONerv + OPsyk combined
          if (this.hasOVask && this.hasONerv && !this.hasOHorm && this.hasOPsyk) {
            this.setResultTemplate(INDICATOR.O_VASK + "Template")
            this.formState.additionalInfo_alt1 = INDICATOR.O_NERV
            this.formState.additionalInfo_alt2 = INDICATOR.O_PSYK
            this.formState.additionalInfo_alt3 = ""
            this.formState.validForRecipe = true
            this.formState.isValidForPsychologicalTreatment = true
            this.formState.displayPsychologyTreatmentInfo = true
          }

          // OVask + OHorm + OPsyk combined
          if (this.hasOVask && !this.hasONerv && this.hasOHorm && this.hasOPsyk) {
            this.setResultTemplate(INDICATOR.O_VASK + "Template")
            this.formState.additionalInfo_alt1 = INDICATOR.O_PSYK
            this.formState.additionalInfo_alt2 = INDICATOR.O_HORM
            this.formState.additionalInfo_alt3 = ""
            this.formState.validForRecipe = true
            this.formState.isValidForPsychologicalTreatment = true
            this.formState.displayPsychologyTreatmentInfo = true
          }

          // OVask + ONerv + OPsyk + OHorm combined
          if (this.hasOVask && this.hasONerv && this.hasOHorm && this.hasOPsyk) {
            this.setResultTemplate(INDICATOR.O_VASK + "Template")
            this.formState.additionalInfo_alt1 = INDICATOR.O_NERV
            this.formState.additionalInfo_alt2 = INDICATOR.O_PSYK
            this.formState.additionalInfo_alt3 = INDICATOR.O_HORM
            this.formState.validForRecipe = true
            this.formState.isValidForPsychologicalTreatment = true
            this.formState.displayPsychologyTreatmentInfo = true
          }

          // ONerv + OPsyk combined
          if (!this.hasOVask && this.hasONerv && !this.hasOHorm && this.hasOPsyk) {
            this.setResultTemplate(INDICATOR.O_NERV + "Template")
            this.formState.additionalInfo_alt1 = INDICATOR.O_PSYK
            this.formState.additionalInfo_alt2 = ""
            this.formState.additionalInfo_alt3 = ""
            this.formState.validForRecipe = true
            this.formState.isValidForPsychologicalTreatment = true
            this.formState.displayPsychologyTreatmentInfo = true
          }

          // ONerv + OHorm combined
          if (!this.hasOVask && this.hasONerv && this.hasOHorm && !this.hasOPsyk) {
            this.setResultTemplate(INDICATOR.O_NERV + "Template")
            this.formState.additionalInfo_alt1 = INDICATOR.O_HORM
            this.formState.additionalInfo_alt2 = ""
            this.formState.additionalInfo_alt3 = ""
            this.formState.validForRecipe = true
            this.formState.isValidForPsychologicalTreatment = false
            this.formState.displayPsychologyTreatmentInfo = false
          }

          // ONerv + OHorm + OPsyk combined
          if (!this.hasOVask && this.hasONerv && this.hasOHorm && this.hasOPsyk) {
            this.setResultTemplate(INDICATOR.O_NERV + "Template")
            this.formState.additionalInfo_alt1 = INDICATOR.O_PSYK
            this.formState.additionalInfo_alt2 = INDICATOR.O_HORM
            this.formState.additionalInfo_alt3 = ""
            this.formState.validForRecipe = true
            this.formState.isValidForPsychologicalTreatment = true
            this.formState.displayPsychologyTreatmentInfo = true
          }
          
          // OPsyk + OHorm combined
          if (!this.hasOVask && !this.hasONerv && this.hasOHorm && this.hasOPsyk) {
            this.setResultTemplate(INDICATOR.O_PSYK + "Template")
            this.formState.additionalInfo_alt1 = INDICATOR.O_HORM
            this.formState.additionalInfo_alt2 = ""
            this.formState.additionalInfo_alt3 = ""
            this.formState.validForRecipe = true
            this.formState.isValidForPsychologicalTreatment = true
            this.formState.displayPsychologyTreatmentInfo = true
            this.formState.psychologyIsPrimaryReason = true
          }

          // Kontraindikationer

          // Only KOAlk
          if (this.hasKOAlk) {
            this.setResultTemplate(INDICATOR.KO_ALK + "Template")
            this.formState.validForRecipe = false
          }

          // Only KOHeart
          if (this.hasKOHeart && !this.hasKOStroke) {
            this.setResultTemplate(INDICATOR.KO_HJART + "Template")
            this.formState.validForRecipe = false
          }

          // Only KOStroke
          if (!this.hasKOHeart && this.hasKOStroke) {
            this.setResultTemplate(INDICATOR.KO_STROKE + "Template")
            this.formState.validForRecipe = false
          }

          // KOHeart + KOStroke
          if (this.hasKOHeart && this.hasKOStroke) {
            this.setResultTemplate(INDICATOR.KO_HJART_OCH_STROKE + "Template")
            this.formState.validForRecipe = false
          }

          // Only KOLiverKidney
          if (this.hasKOLiverKidney && !this.hasKOBloodPressure && !this.hasKOAnatomy) {
            this.setResultTemplate(INDICATOR.KO_LEV_NJUR + "Template")
            this.formState.validForRecipe = false
          }

          // Only KOBloodPressure
          if (!this.hasKOLiverKidney && this.hasKOBloodPressure && !this.hasKOAnatomy) {
            this.setResultTemplate(INDICATOR.KO_BLODTRYCK + "Template")
            this.formState.validForRecipe = false
          }

          // Only KOAnatomy
          if (!this.hasKOLiverKidney && !this.hasKOBloodPressure && this.hasKOAnatomy) {
            this.setResultTemplate(INDICATOR.KO_ANATOMI + "Template")
            this.formState.validForRecipe = false
          }

          // KOLiverKidney + KOBloodPressure
          if (this.hasKOLiverKidney && this.hasKOBloodPressure && !this.hasKOAnatomy) {
            this.setResultTemplate(INDICATOR.KO_BLODTRYCK_OCH_LEV_NJUR + "Template")
            this.formState.validForRecipe = false
          }

          // KOBloodPressure + KOAnatomy
          if (!this.hasKOLiverKidney && this.hasKOBloodPressure && this.hasKOAnatomy) {
            this.setResultTemplate(INDICATOR.KO_BLODTRYCK_OCH_ANATOMI + "Template")
            this.formState.validForRecipe = false
          }

          // KOAnatomy + KOLiverKidney
          if (this.hasKOLiverKidney && !this.hasKOBloodPressure && this.hasKOAnatomy) {
            this.setResultTemplate(INDICATOR.KO_ANATOMI_OCH_LEV_NJUR + "Template")
            this.formState.validForRecipe = false
          }

          // KOLiverKidney + KOBloodPressure + KOAnatomy
          if (this.hasKOLiverKidney && this.hasKOBloodPressure && this.hasKOAnatomy) {
            this.setResultTemplate(INDICATOR.KO_BLODTRYCK_OCH_ANATOMI_OCH_LEV_NJUR + "Template")
            this.formState.validForRecipe = false
          }

          // Only KOMedicine
          if (this.hasAnyMedicine && this.formState.hasKOMedicine && !this.formState.hasKOMedicineAdempas && !this.formState.hasKOMedicineHiv && !this.formState.hasKOMedicineCancer) {
            this.setResultTemplate(INDICATOR.KO_LAKEMEDEL + "Template")
            this.formState.validForRecipe = false
          }

          // KOMedicine + KOMedicineHiv
          if (this.hasAnyMedicine && this.formState.hasKOMedicineHiv && !this.formState.hasKOMedicineCancer) {
            this.setResultTemplate(INDICATOR.KO_LAKEMEDEL_HIV + "Template")
            this.formState.validForRecipe = false
          }

          // Only KOMedicineAdempas
          if (this.hasAnyMedicine && !this.formState.hasKOMedicine && this.formState.hasKOMedicineAdempas) {
            this.setResultTemplate(INDICATOR.KO_LAKEMEDEL_ADEMPAS + "Template")
            this.formState.validForRecipe = false
          }

          // KOMedicine + KOMedicineAdempas
          if (this.hasAnyMedicine && this.formState.hasKOMedicine && this.formState.hasKOMedicineAdempas) {
            this.setResultTemplate(INDICATOR.KO_LAKEMEDEL_ADEMPAS + "Template")
            this.formState.validForRecipe = false
          }

          // KOMedicine + KOMedicineCancer
          if (this.hasAnyMedicine && !this.formState.hasKOMedicineHiv && this.formState.hasKOMedicineCancer) {
            this.setResultTemplate(INDICATOR.KO_LAKEMEDEL_CANCER + "Template")
            this.formState.validForRecipe = false
          }

          // KOMedicine + KOMedicineHiv + KOMedicineCancer
          if (this.hasAnyMedicine && this.formState.hasKOMedicineHiv && this.formState.hasKOMedicineCancer) {
            this.setResultTemplate(INDICATOR.KO_LAKEMEDEL_HIV_OCH_CANCER + "Template")
            this.formState.validForRecipe = false
          }

          // Only KOTvasc
          if (this.hasKOTvasc) {
            this.setResultTemplate(INDICATOR.KO_TVASK + "Template")
            this.formState.validForRecipe = false
          }

        }

        this.formState.navForwardVisible = false
      } else {
        this.setResultTemplate("")

        this.formState.navForwardVisible = true
      }
    },
    hasSymptoms(newValue) {
      this.formState.hasSymptoms = newValue
    },
    hasAnyMedicine(newValue) {
      this.formState.hasAnyMedicine = newValue
    },
    hasKOAlk(newValue) {
      this.formState.hasKOAlk = newValue
    },
    hasKOHeart(newValue) {
      this.formState.hasKOHeart = newValue
    },
    hasKOStroke(newValue) {
      this.formState.hasKOStroke = newValue
    },
    hasKOLiverKidney(newValue) {
      this.formState.hasKOLiverKidney = newValue
    },
    hasKOBloodPressure(newValue) {
      this.formState.hasKOBloodPressure = newValue
    },
    hasKOAnatomy(newValue) {
      this.formState.hasKOAnatomy = newValue
    },
    hasKOTvasc(newValue) {
      this.formState.hasKOTvasc = newValue
    },
    hasKOMedicine(newValue) {
      this.formState.hasKOMedicine = newValue
    },
    hasKOMedicineAdempas(newValue) {
      this.formState.hasKOMedicineAdempas = newValue
    },
    hasKOMedicineHiv(newValue) {
      this.formState.hasKOMedicineHiv = newValue
    },
    hasKOMedicineCancer(newValue) {
      this.formState.hasKOMedicineCancer = newValue
    }

  },
  computed: {
    isComplete() {
      return this.formState.isComplete
    },
    isValidForRecipe() {
      return this.formState.validForRecipe
    },
    cleanData() {
      return formatData(this.$store.state.lead.formData)
    },
    kaddioData() {
      return prepareKaddioData(this.cleanData)
    },
    symptomsCount() {
      return calculateResults(this.cleanData, INDICATOR.NO_SYMPTOM)
    },
    oVaskCount() {
      return calculateResults(this.cleanData, INDICATOR.O_VASK)
    },
    oNervCount() {     
      return calculateResults(this.cleanData, INDICATOR.O_NERV)
    },
    oHormCount() {
      return calculateResults(this.cleanData, INDICATOR.O_HORM)
    },
    oPsykCount() {
      return calculateResults(this.cleanData, INDICATOR.O_PSYK)
    },
    koAlkCount() {
      return calculateResults(this.cleanData, INDICATOR.KO_ALK)
    },
    koHjartCount() {
      return calculateResults(this.cleanData, INDICATOR.KO_HJART)
    },
    koStrokeCount() {
      return calculateResults(this.cleanData, INDICATOR.KO_STROKE)
    },
    koLevNjurCount() {
      return calculateResults(this.cleanData, INDICATOR.KO_LEV_NJUR)
    },
    koBloodPrCount() {
      return calculateResults(this.cleanData, INDICATOR.KO_BLODTRYCK)
    },
    koAnatomyCount() {
      return calculateResults(this.cleanData, INDICATOR.KO_ANATOMI)
    },
    koTraumaticVascCount() {
      return calculateResults(this.cleanData, INDICATOR.KO_TVASK)
    },
    koAnyMedicineCount() {
      return calculateResults(this.cleanData, INDICATOR.LAKEMEDEL)
    },
    koMedicineCount() {
      return calculateResults(this.cleanData, INDICATOR.KO_LAKEMEDEL)
    },
    koMedicineAdempasCount() {
      return calculateResults(this.cleanData, INDICATOR.KO_LAKEMEDEL_ADEMPAS)
    },
    koMedicineHivCount() {
      return calculateResults(this.cleanData, INDICATOR.KO_LAKEMEDEL_HIV)
    },
    koMedicineCancerCount() {
      return calculateResults(this.cleanData, INDICATOR.KO_LAKEMEDEL_CANCER)
    },
    hasSymptoms() {
      return this.symptomsCount > 0 ? true : false
    },
    hasOVask() {
      return this.oVaskCount > 0 ? true : false
    },
    hasONerv() {
      return this.oNervCount > 0 ? true : false
    },
    hasOHorm() {
      return this.oHormCount > 0 ? true : false
    },
    hasOPsyk() {
      return this.oPsykCount > 0 ? true : false
    },
    hasKOAlk() {
      return this.koAlkCount > 0 ? true : false
    },
    hasAnyMedicine() {
      return this.koAnyMedicineCount > 0 ? true : false
    },
    hasKOHeart() {
      return this.koHjartCount > 0 ? true : false
    },
    hasKOStroke() {
      return this.koStrokeCount > 0 ? true : false
    },
    hasKOLiverKidney() {
      return this.koLevNjurCount > 0 ? true : false
    },
    hasKOBloodPressure() {
      return this.koBloodPrCount > 0 ? true : false
    },
    hasKOAnatomy() {
      return this.koAnatomyCount > 0 ? true : false
    },
    hasKOTvasc() {
      return this.koTraumaticVascCount > 0 ? true : false
    },
    hasKOMedicine() {
      return this.koMedicineCount > 0 ? true : false
    },
    hasKOMedicineAdempas() {
      return this.koMedicineAdempasCount > 0 ? true : false
    },
    hasKOMedicineHiv() {
      return this.koMedicineHivCount > 0 ? true : false
    },
    hasKOMedicineCancer() {
      return this.koMedicineCancerCount > 0 ? true : false
    },
    isValidForPsychologicalTreatment() {
      return this.formState.isValidForPsychologicalTreatment
    },
    displayPsychologyTreatmentInfo() {
      return this.formState.displayPsychologyTreatmentInfo
    },
    psychologyIsPrimaryReason() {
      return this.formState.psychologyIsPrimary
    }
  }
}

function formatData(data) {
  var formattedData = []
  
  //eslint-disable-next-line no-unused-vars
  Object.entries(data).forEach(([key, value]) => {
    if (value) {
      let resultEntry = {}
      let resultEntryArray = []
      resultEntry.name = key

      if (Array.isArray(value)) {
        value.forEach(val => {
          let keySuffix = key + "_option_" + val.id
          val.answer = true
          val.definition = getFieldDefinition(keySuffix).definition
          val.indicator = getFieldDefinition(keySuffix).indicator
          resultEntryArray.push(val)
          resultEntry.result = resultEntryArray
        })
      } else {
        resultEntry.result = [
          {
            id: 1,
            question: getFieldDefinition(key).question,
            answer: value,
            definition: getFieldDefinition(key).definition,
            indicator: getFieldDefinition(key).indicator,
            kaddioFormId: getFieldDefinition(key).kaddioId
          }
        ]
      }

      formattedData.push(resultEntry)
    }
  })

  return formattedData
}

function prepareKaddioData(data) {
  let dataStr = ""
  let kaddioDataArr = []
  
  //eslint-disable-next-line no-unused-vars
  Object.entries(formConfig).forEach(([key, value]) => { 

      if (value) {

        if (value.type === "switch") {
          let dataInner = {}

          dataInner.id = value.kaddioFormId;
          dataInner.question = value.question;
          dataInner.answer = null;

          kaddioDataArr.push(dataInner)

        }

        if (value.type === "switchgroup") { 
          //eslint-disable-next-line no-unused-vars        
          Object.entries(value.options.choices).forEach(([key, val]) => {
            let dataGroupInner = {}
            
            dataGroupInner.id = val.kaddioFormId
            dataGroupInner.question = val.question;
            dataGroupInner.answer = null;

            kaddioDataArr.push(dataGroupInner)
          })
        }

        
    }
  })

  //eslint-disable-next-line no-unused-vars
  Object.entries(data).forEach(([key, dval]) => { 

    if (dval.hasOwnProperty('result')) {

      if (dval.result.length > 1) {
        dval.result.forEach(ddval => {

          for (let i = 0; i < kaddioDataArr.length; i++) {
            let kaddioEntry = kaddioDataArr[i];
            
            if (kaddioEntry.id === ddval.kaddioFormId) {
              kaddioEntry.answer = true
              kaddioEntry.indicator = ddval.indicator
            } 
          }

        })
      } else {
          for (let x = 0; x < kaddioDataArr.length; x++) {
            let kaddioEntry = kaddioDataArr[x];
            
            if (kaddioEntry.id === dval.result[0].kaddioFormId) {
              kaddioEntry.answer = true
              kaddioEntry.indicator = dval.result[0].indicator
            } 
          }

      }

    }
  })

  for (let y = 0; y < kaddioDataArr.length; y++) {
    let oneFieldStr = ""

    let kaddioEntry = kaddioDataArr[y];
    
        oneFieldStr += "Id: " + kaddioEntry.id + "\n";
        oneFieldStr += "Fråga: " + kaddioEntry.question + "\n";

        if (kaddioEntry.answer === true) {
          oneFieldStr += "Svar: JA\n";
          oneFieldStr += "Indikator: " + kaddioEntry.indicator + "\n\n";
        } else {
          oneFieldStr += "Svar: NEJ\n\n";
        }
        oneFieldStr += "- - -\n\n";

      dataStr += oneFieldStr;
  }
  return dataStr
}

function calculateResults(collection, indicator) {
  let counter = 0
  collection.forEach(entry => {
    if (entry.hasOwnProperty("result")) { 
      entry.result.forEach(result => {
        if (result.indicator === indicator) {
          counter += 1
        }
      })
    }
  })
  return counter
}

function pushBankIdEventToDataLayer(eventName) { 
  window.dataLayer.push({
    'event': eventName
  });
}

</script>
